import { useSyncExternalStore } from 'react';
import { subscribeHealth, getHealthSnapshot } from '../lib/airtableHealth';

export function useAirtableOutage() {
  return useSyncExternalStore(subscribeHealth, getHealthSnapshot);
}
